import React, { Component } from "react";
import { matchPath } from "react-router";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as MultipliersActions } from "store/ducks/multipliers";

import { Validate, Access } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Points/Multipliers/components";

class Edit extends Component {
  state = {
    data: {
      description: "",
      multiplier: "",
      start_at: null,
      end_at: null,
      active: false,
      store_channels: Access.lockedChannel()
        ? [Access.lockedChannel(true)]
        : [],
      store_channels_all: false,
      extra_data: {
        store_region: null,
        store_places: [],
        store_places_all: true,
        classification_passions: [],
        classification_passions_all: true,
        store_product_types: [],
        store_product_types_all: true,
        store_sections: [],
        store_sections_all: true,
        store_sub_sections: [],
        store_sub_sections_all: true,
        store_groups: [],
        store_sub_groups: [],
        remove_mdh: false,
        add_mdh: false,
        add_store_products: [],
        remove_store_products: [],
        send_email: true,
        all_products: false,
      },
    },
    errors: {},
    loading: true,
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "/points" },
      { name: "Campanha de Pontos", to: "/points/multiplier" },
      { name: "Adicionar Novo", to: "" },
    ],
  };

  componentDidMount() {
    const { getMultiplierRequest } = this.props;
    getMultiplierRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { multiplier } = this.props;

    if (oldProps.multiplier.loading && !multiplier.loading) {
      const values = {
        ...data,
        ...multiplier.data.attributes,
        id: multiplier.data.id,
        description:
          multiplier.data.attributes.description !== null
            ? multiplier.data.attributes.description
            : "",
        store_channels:
          multiplier.data.attributes.channels !== null
            ? multiplier.data.attributes.channels.map((channel) => ({
                value: channel.id,
                label: channel.name,
              }))
            : [],
        store_channels_all:
          multiplier.data.attributes.channels !== null
            ? !multiplier.data.attributes.channels.length
            : true,
        store_region:
          multiplier.data.attributes.regions !== null
            ? multiplier.data.attributes.regions.map((region) => ({
                value: region.id,
                label: region.name,
              }))
            : [],
        start_at:
          multiplier.data.attributes.start_at !== null
            ? new Date(multiplier.data.attributes.start_at)
            : null,
        end_at:
          multiplier.data.attributes.end_at !== null
            ? new Date(multiplier.data.attributes.end_at)
            : null,
      };

      this.setState({
        data: values,
        loading: false,
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/points/multiplier/:id/edit",
    });
    return match.params.id;
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      description: {
        required: true,
      },

      multiplier: {
        required: true,
      },

      start_at: {
        required: true,
      },

      end_at: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  render() {
    const { data, errors, breadcrumbs, loading } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          loading={loading}
          errors={errors}
          edit
          saving={update.loading}
          onChange={this.handleChange}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  multiplier: state.multipliers.detail,
  update: state.multipliers.update,
});

const mapActions = (dispatch) =>
  bindActionCreators(MultipliersActions, dispatch);

export default connect(mapState, mapActions)(Edit);
